<template>
  <div id="app">
    <!-- 新增：全局通知栏组件 -->
    <GlobalNotification
      type="info"
      :message="notificationMessage"
      :duration="0"
      storageKey="janekao_notice_202511"
    />
    <SiteHeader />
    <main class="main-content">
      <div class="container">
        <router-view />
      </div>
    </main>

    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from "@/components/Header.vue";
import SiteFooter from "@/components/Footer.vue";
// 导入通知栏组件
import GlobalNotification from "@/components/Notification.vue";
export default {
  name: "App",
  components: {
    SiteHeader,
    SiteFooter,
    GlobalNotification,
  },
  data() {
    return {
      // 通知内容（支持HTML）
      notificationMessage: `
        <strong>📢 数据更新通知</strong><br>
        已更新数据，最新时间 <strong>2025年12月</strong>，将持续不定期更新。<br>
        欢迎收藏本页，获取最新动态！🎉
      `,
    };
  },
};
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", "Microsoft YaHei", sans-serif;
}

:root {
  --primary-color: #ff6b9d;
  --secondary-color: #6a5acd;
  --light-color: #f9f7fe;
  --dark-color: #2c2c54;
  --text-color: #333;
  --text-light: #666;
  --border-color: #e0e0e0;
  --shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  --transition: all 0.3s ease;
}

body {
  background-color: var(--light-color);
  color: var(--text-color);
  line-height: 1.6;
  overflow-x: hidden;
}

/* 响应式布局 */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 头部样式 */
.header {
  background: linear-gradient(
    135deg,
    var(--primary-color),
    var(--secondary-color)
  );
  color: white;
  padding: 15px 0; /* 减小上下内边距 */
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: var(--shadow);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 1.8rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo i {
  font-size: 2rem;
}

.nav {
  display: flex;
  align-items: center;
}

.nav-links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-links li {
  margin-left: 12px; /* 减小导航项间距 */
}

.nav-links a {
  color: white;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9rem; /* 减小导航文字大小 */
  transition: var(--transition);
  padding: 5px 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: nowrap; /* 防止导航文字换行 */
  min-width: 50px; /* 设置最小宽度 */
}

.nav-links a i {
  font-size: 1.1rem; /* 导航图标大小 */
  margin-bottom: 2px; /* 图标和文字的间距 */
}

.nav-text {
  font-size: 0.75rem; /* 导航文字更小 */
  line-height: 1.1;
  text-align: center;
}

.nav-links a:hover {
  opacity: 0.9;
}

.nav-links a.active {
  border-bottom: 2px solid white;
}
/* 移动端汉堡菜单 */
.hamburger {
  display: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: white;
}

/* 主要内容区域 */
.main-content {
  padding: 20px 0;
  min-height: calc(100vh - 200px);
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
  color: var(--dark-color);
  position: relative;
}

.section-title h2 {
  font-size: 2.2rem;
  margin-bottom: 10px;
  display: inline-block;
}

.section-title::after {
  content: "";
  display: block;
  width: 70px;
  height: 3px;
  background: linear-gradient(
    to right,
    var(--primary-color),
    var(--secondary-color)
  );
  margin: 10px auto 0;
}

/* 板块内容样式 */
.section-content {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: var(--shadow);
  margin-bottom: 30px;
}

.placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  color: var(--text-light);
}

.placeholder-content i {
  font-size: 4rem;
  color: var(--primary-color);
  margin-bottom: 20px;
}

.placeholder-content h3 {
  font-size: 1.8rem;
  margin-bottom: 15px;
  color: var(--dark-color);
}

.placeholder-content p {
  max-width: 600px;
  margin-bottom: 25px;
}

.btn {
  background: linear-gradient(
    to right,
    var(--primary-color),
    var(--secondary-color)
  );
  color: white;
  border: none;
  padding: 12px 28px;
  border-radius: 50px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  display: inline-block;
  text-decoration: none;
  font-size: 1rem;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(255, 107, 157, 0.3);
}

/* 页脚样式 */
.footer {
  background-color: var(--dark-color);
  color: white;
  padding: 40px 0 20px;
  margin-top: 0px;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
}

.footer-section {
  flex: 1;
  min-width: 250px;
  margin-bottom: 10px;
  padding: 0 15px;
}

.footer-section h3 {
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: var(--primary-color);
}

.footer-links {
  list-style: none;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  color: #ddd;
  text-decoration: none;
  transition: var(--transition);
  font-size: 0.9rem;
}

.footer-links a:hover {
  color: var(--primary-color);
  padding-left: 5px;
}

.copyright {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.8rem;
  color: #aaa;
}
/* 全局去除链接下划线 */
a,
a:link,
a:visited,
a:hover,
a:focus,
a:active {
  text-decoration: none !important;
  color: inherit; /* 可选：继承父元素颜色 */
}
/* 移动端响应式设计 */
@media screen and (max-width: 992px) {
  .section-title h2 {
    font-size: 1.8rem;
  }

  .section-content {
    padding: 20px;
  }
}

@media screen and (max-width: 768px) {
  .header-content {
    flex-wrap: wrap;
  }

  .nav-links {
    display: none;
    flex-direction: column;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    position: absolute;
    top: 100%;
    left: 0;
    padding: 20px 0;
    z-index: 999;
  }

  .nav-links.active {
    display: flex;
  }

  .nav-links li {
    margin: 10px 0;
    text-align: center;
  }

  .hamburger {
    display: block;
  }

  .footer-section {
    flex: 100%;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .logo {
    font-size: 1.5rem;
  }

  .section-title h2 {
    font-size: 1.6rem;
  }

  .btn {
    padding: 10px 22px;
    font-size: 0.9rem;
  }
}

/* 板块特色样式 */
.cp-highlight {
  background: linear-gradient(
    135deg,
    rgba(255, 107, 157, 0.1),
    rgba(106, 90, 205, 0.1)
  );
  border-left: 5px solid var(--primary-color);
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 20px;
}

.image-item {
  height: 180px;
  background-color: #f0f0f0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-light);
  font-size: 0.9rem;
}
</style>
